
import { Modal } from "react-bootstrap";
const OrderOffersModal = ({ showOffersModal, setShowOffersModal, selectedOffersOrder }) => {
return (    
<Modal
show={showOffersModal}
onHide={() => setShowOffersModal(false)}
size="lg"
centered
>
<Modal.Header closeButton>
  <Modal.Title>
    {selectedOffersOrder ? (
      <>Order #{selectedOffersOrder.id} - Offers</>
    ) : (
      "Order Offers"
    )}
  </Modal.Title>
</Modal.Header>
<Modal.Body>
  {selectedOffersOrder && selectedOffersOrder.order_offers && selectedOffersOrder.order_offers.length > 0 ? (
    selectedOffersOrder.order_offers.map((offer) => (
      <div key={offer.id} className="mb-4">
        <h5>{offer.offer_name}</h5>
        <p><strong>Offer ID:</strong> {offer.id}</p>
        {offer.order_offer_items && offer.order_offer_items.length > 0 ? (
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>SKU</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {offer.order_offer_items.map((item) => (
                <tr key={item.id}>
                  <td>{item.item_name}</td>
                  <td>{item.item_sku}</td>
                  <td>{item.item_quantity}</td>
                  <td>{item.item_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No items for this offer.</p>
        )}
      </div>
    ))
  ) : (
    <p>No offers available for this order.</p>
  )}
</Modal.Body>
</Modal>)};
export default OrderOffersModal;